
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 668 611","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('style',[_v('.st0{fill:#0097a7}')]),_c('path',{staticClass:"st0",attrs:{"d":"M510.3 485.7c-1.7 0-3.5-.3-5.2-.9l-421.3-144c-6.1-2.1-10.3-7.6-10.8-13.9-.5-6.4 2.9-12.4 8.5-15.4l480-250.7c5.4-2.8 11.8-2.3 16.7 1.2 4.9 3.5 7.4 9.4 6.6 15.4L526.2 472c-.7 4.7-3.5 8.8-7.5 11.3-2.6 1.6-5.5 2.4-8.4 2.4zM129.4 322.6l367.9 125.7 51.2-344.6-419.1 218.9z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M275.7 549.7c-1.7 0-3.3-.3-5-.8-6.6-2.2-11-8.3-11-15.2v-144c0-4 1.5-8 4.3-10.9L557.3 64.1c6-6.5 16.2-6.8 22.6-.8 6.5 6 6.8 16.1.8 22.6l-289 310v88.9l53.4-72.7c5.2-7.1 15.3-8.7 22.4-3.4 7.1 5.2 8.6 15.3 3.4 22.4l-82.3 112c-3.1 4.2-7.9 6.6-12.9 6.6z"}})])
          )
        }
      }
    